import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h2", null, "Recipe", -1)
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Recipe Name: ")
const _hoisted_3 = ["onUpdate:modelValue"]
const _hoisted_4 = ["onUpdate:modelValue"]

import { onMounted, reactive, watch } from 'vue'
import { buildShortRecipeQueryParameter, Ingredient, Recipe } from 'fabri-core'

// --- types ---
interface Emits {
  (eventName: 'recipeChanged', recipe: Recipe): void
}

// --- state ---

export default /*#__PURE__*/_defineComponent({
  emits: ["recipeChanged"],
  setup(__props, { emit: emits }: { emit: ({
  (eventName: 'recipeChanged', recipe: Recipe): void
}), expose: any, slots: any, attrs: any }) {



const currentRecipe = reactive<Recipe>({
  name: '',
  ingredients: []
})

const emptyIngredient: Ingredient = {
  name: '',
  quantity: ''
}

// --- Behavior ---
const tryAddNewIngredientRow = (newRecipe: Recipe) => {
  const hasNoIngredientYet = !newRecipe.ingredients.length
  const lastIngredient = newRecipe.ingredients[newRecipe.ingredients.length - 1]
  if (hasNoIngredientYet || lastIngredient?.name) {
    newRecipe.ingredients.push({ ...emptyIngredient })
  }
}

const getTitleForRecipe = (recipe: Recipe) =>
  recipe.name
    ? `fabri - ${recipe.name}`
    : 'fabri'

const updateQueryParameter = (recipe: Recipe) => {
  const searchParamsWithoutUnecessaryEquals = buildShortRecipeQueryParameter(recipe)

  const title = getTitleForRecipe(recipe)
  window.history.replaceState(recipe.name, title, searchParamsWithoutUnecessaryEquals ? `?${searchParamsWithoutUnecessaryEquals}` : null)
  document.title = title
}

const initializeRecipeByURL = () => {
  const searchParams = new URLSearchParams(window.location.search)

  currentRecipe.name = searchParams.get('n') || ''
  searchParams.delete('n')

  searchParams.forEach((quantity, name) => {
    currentRecipe.ingredients.push({
      name: name,
      quantity: quantity
    })
  })
  document.title = getTitleForRecipe(currentRecipe)
}

// --- Lifecycle Hooks ---
onMounted(() => {
  initializeRecipeByURL()
})

const withoutEmptyIngredients = (recipe: Recipe): Recipe => {
  return {
    ...recipe,
    ingredients: recipe?.ingredients?.filter(it => !!it.name) || []
  }
}

watch(currentRecipe, (newRecipe: Recipe) => {
  emits('recipeChanged', withoutEmptyIngredients(newRecipe))
  tryAddNewIngredientRow(newRecipe)
  updateQueryParameter(newRecipe)
}, {
  deep: true
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createElementVNode("form", {
      onSubmit: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"]))
    }, [
      _createElementVNode("label", null, [
        _hoisted_2,
        _withDirectives(_createElementVNode("input", {
          placeholder: "Hot Sweet Sour Salty Something",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(currentRecipe).name) = $event))
        }, null, 512), [
          [_vModelText, _unref(currentRecipe).name]
        ])
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(currentRecipe).ingredients, (ingredient, ingredientIndex) => {
        return (_openBlock(), _createElementBlock("div", { key: ingredientIndex }, [
          _createElementVNode("label", null, [
            _createTextVNode(" Ingredient " + _toDisplayString(ingredientIndex + 1) + ": ", 1),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": ($event: any) => ((ingredient.name) = $event)
            }, null, 8, _hoisted_3), [
              [_vModelText, ingredient.name]
            ])
          ]),
          _createElementVNode("label", null, [
            _createTextVNode(" Quantity " + _toDisplayString(ingredientIndex + 1) + ": ", 1),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": ($event: any) => ((ingredient.quantity) = $event)
            }, null, 8, _hoisted_4), [
              [_vModelText, ingredient.quantity]
            ])
          ])
        ]))
      }), 128))
    ], 32)
  ]))
}
}

})